import React, { useState } from 'react'
import useFirebase from '../../../firebase/useFirebase'

const useClients = () => {
    const { updateData } = useFirebase()

    const _subtractCardFidelity = (countCardLoyalty,key,id) => { 
        if (countCardLoyalty > 0) {
            const data = {countCardLoyalty: countCardLoyalty - 1}
            updateData('entreprises/'+key+'/clients/'+id,data)
        }
        console.log('_substract card ', countCardLoyalty) 
    }

    const _addCardFidelity = (countCardLoyalty,key,id,loyaltyCard) => {
        if (countCardLoyalty < loyaltyCard) {
            const data = {countCardLoyalty: countCardLoyalty + 1}
            updateData('entreprises/'+key+'/clients/'+id,data)
        }
        console.log('_substract card ', countCardLoyalty)
    }

    const _deleteCardFidelity = (countCardLoyalty,key,id,loyaltyCard) => {
        if (countCardLoyalty.toString() === loyaltyCard.toString()) {
            const data = {countCardLoyalty: 0}
            updateData('entreprises/'+key+'/clients/'+id,data)
        }
        console.log('_deleteCardFidelity card ', countCardLoyalty)
    }

    // ALLOW BOOKING
    const _allowBooking = (allow,key,id) => {
        const data = allow === false ? {'allow':true} : {'allow':false}
        updateData('entreprises/'+key+'/clients/'+id,data)
    }



    return { _subtractCardFidelity, _addCardFidelity, _deleteCardFidelity, _allowBooking }
}

export default useClients

